import React from 'react';
import { DateConverter } from '../components/date-converter/DateConverter';
import '../components/date-converter/DateConverter.css';

export const DateConverterPage: React.FC = () => {
  return (
    <div className="page-container">
      <DateConverter />
    </div>
  );
};